import restApi from "@plannel/services/utils/rest-api";

const getAudit = params => {
  return restApi.get("/api/audit-logs", { params });
}

const getEntityNames = params => {
  return restApi.get("/api/audit-logs/entities", { params });
}

const getUserList = params => {
  return restApi.get("/api/audit-logs/users", { params });
}

const auditService = {
  getAudit,
  getEntityNames,
  getUserList
};

export default auditService;